export const DBNP_RESET_STATE = 'DBNP_RESET_STATE';
export const DBNP_CURRENT_ITEM = 'DBNP_CURRENT_ITEM';

export const DBNP_REQUEST_LOADING = 'DBNP_REQUEST_LOADING';
export const DBNP_REQUEST_SUCCESS = 'DBNP_REQUEST_SUCCESS';
export const DBNP_REQUEST_FAILED = 'DBNP_REQUEST_FAILED';

export const DBNP_CURRENT_ACTION = 'DBNP_CURRENT_ACTION';
export const DBNP_RESET_ACTION = 'DBNP_RESET_ACTION';